import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import Select from "react-select";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addQuestionnaireText, editQuestionnaireText } from "store/actions";
import { fetchQuestionnaireBatchList, fetchQuestionnaireList, onCreateGroupNorms } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const MailSendModel = props => {
    const { modal, toggle, isEdit, itemData, fetchGroupNormsListData } = props
    const [questionnaireList, setQuestionnaireList] = useState()
    const [options, setoptions] = useState([]);
    const [selectValue, setSelectValue] = useState()
    const [batchQuestionnaireData, setBatchQuestionnaireData] = useState()
    const { state } = useLocation();
    const [selectedIds, setSelectedIds] = useState([]);
    const [loadingGenerate, setloadingGenerate] = useState(false);


    // Function to toggle the selection of a checkbox
    const toggleCheckbox = (id) => {
        if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter(item => item !== id));
        } else {
            setSelectedIds([...selectedIds, id]);
        }
    };

    // fetch language
    const fetchQuestionnaireLists = async () => {
        try {
            const listQuestion = await fetchQuestionnaireList();
            setQuestionnaireList(listQuestion?.data);
        } catch (error) {

        }

    }

    useEffect(() => {
        fetchQuestionnaireLists()
    }, [])

    const clearData = () => {
        validation.resetForm({
            norm_name: ''
        })
        setSelectedIds([])
        setSelectValue(null)
        setBatchQuestionnaireData([])
    }   

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
        },
        validationSchema: Yup.object({
            norm_name: Yup.string().required(props.t("Please Enter Norm Name")),
        }),
        onSubmit: async(values, { resetForm }) => {
                setloadingGenerate(true)
                 values = {
                    ...values,
                    "questionnaire_id": selectValue?.value,
                    "batch_id": selectedIds
                }
                try {
                    const createReport = await onCreateGroupNorms(values);
                    if(createReport?.status == 'success'){
                        toastr.success(createReport?.message)
                        clearData()
                        setloadingGenerate(false)
                        fetchGroupNormsListData();
                        toggle()
                    }else {
                        setloadingGenerate(false)
                        toastr.error(createReport?.message)

                    }
                } catch (error) {
                    toastr.success(error?.message)
                    // setloadingGenerate(false)
                    
                }

        }
    });

    useEffect(() => {
        let modifiedList = questionnaireList?.map(dky => ({
            value: dky.id,
            label: dky.questionnaire_name,
        }))
        setoptions(modifiedList)
    }, [questionnaireList])

    const handleSelectChange = async(obj) => {
        setSelectValue(obj)
        try {
            const batchQuestionnaire = await fetchQuestionnaireBatchList(obj?.value);
            setBatchQuestionnaireData(batchQuestionnaire?.data && Object.keys(batchQuestionnaire.data).length === 0 ? [] : batchQuestionnaire?.data)
        } catch (error) {
            
        }
    }

    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    setSelectValue()
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        setSelectValue()

                    }}>
                    { props.t("Generate Group Norms")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Select Questionnaire")}:</Label>
                            <Select
                                className="custom-select-search-option"
                                options={options}
                                value={selectValue}
                                name="question_id"
                                onChange={handleSelectChange}
                            />
                        </div>
                        <div className="mb-3 d-block">
                            {
                                batchQuestionnaireData?.map((data, index) => {
                                    return (
                                        <div className="generate-checkbox" key= {index}>
                                            <Label for={data.id} className="form-label m-0 pb-1 generate-checkbox-inner">{data?.title}
                                            <input
                                                id={data.id}
                                                type="checkbox"
                                                checked={selectedIds.includes(data.id)}
                                                onChange={() => toggleCheckbox(data.id)}
                                                onClick={() => toggleCheckbox(data.id)}
                                            />
                                            <span className="checkmark"></span>
                                            </Label>
                                        </div>
                                    ) 
                                })
                            }

                        </div>

                        <div className="mb-3 d-block modal-50">
                                <Label className="form-label m-0 pb-1">{props.t("Group Norms")}:</Label>
                                <Input
                                    name="norm_name"
                                    className="form-control"
                                    placeholder={props.t("Enter Group Norms Name")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.norm_name || ""}
                                    invalid={
                                        validation.touched.norm_name && validation.errors.norm_name ? true : false
                                    }
                                />
                                {validation.touched.norm_name && validation.errors.norm_name ? (
                                    <FormFeedback type="invalid">{validation.errors.norm_name}</FormFeedback>
                                ) : null}
                        </div>
                        <div className="btn-login-admin mt-3 batches-add-modal-btn">
                            {
                                loadingGenerate ?
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                        disabled
                                    >
                                        {props.t("...Generate")}
                                    </button>
                                    :
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Generate")}
                                    </button>
                            }

                        </div>

                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


MailSendModel.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(MailSendModel);
